import { Divider, Grid, List, ListItem, ListItemText } from '@material-ui/core'

import '../../styles.css'

export default function ResumeContents({
  classes,
  answers,
  formSelected
}) {
  return(
    <List className='List'>
      {answers.map(answer => (
        <Grid item sm={12} xs={12} key={answer.field_id}>
          <ListItem
            alignItems='flex-start'
            button
          >
            <ListItemText
              primary={answer.value}
              secondary={formSelected.fields.find(field => field.field_id === answer.field_id).summary_title}
            />
          </ListItem>
          <Divider variant='fullWidth' component='li' />
        </Grid>
      ))}
    </List>
  )
}